import React, { useState, useEffect } from "react";
import PageShell from "../../components/layout/PageShell";

export default function Temoignages() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: "Juge Jean Dupont",
      title: "Tribunal de première instance de Port-au-Prince",
      year: "Promotion 2018",
      quote: "La formation à l'EMA m'a donné les outils nécessaires pour exercer ma fonction avec rigueur et intégrité. Chaque jour, je m'efforce de rendre justice avec équité et professionnalisme.",
      category: "Diplômé"
    },
    {
      name: "Juge Marie Pierre",
      title: "Cour d'appel de Cap-Haïtien",
      year: "Promotion 2019",
      quote: "L'EMA m'a préparée aux défis de la magistrature. Les stages pratiques et les enseignements théoriques m'ont permis de développer les compétences essentielles à mon rôle de juge.",
      category: "Diplômé"
    },
    {
      name: "Juge Pierre Joseph",
      title: "Tribunal de paix de Jacmel",
      year: "Promotion 2020",
      quote: "Les stages pratiques m'ont permis de développer les compétences essentielles à mon rôle. La formation continue de l'EMA me permet de rester à jour avec les évolutions juridiques.",
      category: "Diplômé"
    },
    {
      name: "Juge Rose-Anne Michel",
      title: "Tribunal pour enfants de Port-au-Prince",
      year: "Promotion 2021",
      quote: "La formation continue de l'EMA me permet de rester à jour avec les évolutions juridiques et d'améliorer constamment ma pratique judiciaire.",
      category: "Diplômé"
    },
    {
      name: "Greffier Jean-Baptiste",
      title: "Greffe du Tribunal de Port-au-Prince",
      year: "Formation continue 2023",
      quote: "Les formations continues de l'EMA sont indispensables pour notre profession. Elles nous permettent de nous perfectionner et d'offrir un service de qualité.",
      category: "Greffier"
    },
    {
      name: "Formateur Michel Célestine",
      title: "Professeur de droit civil",
      year: "Formateur depuis 2015",
      quote: "Former les futurs magistrats est une mission noble. Voir nos élèves réussir et servir la justice avec intégrité est notre plus grande récompense.",
      category: "Formateur"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 6000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageShell
      title="Témoignages"
      subtitle="Les expériences de nos diplômés, formateurs et partenaires"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Voix de la communauté EMA</h2>
        <p className="ema-lead">
          Découvrez les témoignages de magistrats formés à l'École de la Magistrature qui exercent aujourd'hui
          dans les tribunaux de tout le pays, ainsi que ceux de nos formateurs et partenaires institutionnels.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Carrousel de témoignages */}
      <section className="ema-block">
        <div className="ema-testimonial-carousel" style={{
          position: 'relative',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          {/* Navigation */}
          <button
            onClick={prevSlide}
            style={{
              position: 'absolute',
              left: '-60px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              border: '2px solid #0B2C5F',
              background: '#fff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              zIndex: 10
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#0B2C5F';
              e.currentTarget.querySelector('svg').style.stroke = '#fff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.querySelector('svg').style.stroke = '#0B2C5F';
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <button
            onClick={nextSlide}
            style={{
              position: 'absolute',
              right: '-60px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              border: '2px solid #0B2C5F',
              background: '#fff',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              zIndex: 10
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#0B2C5F';
              e.currentTarget.querySelector('svg').style.stroke = '#fff';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#fff';
              e.currentTarget.querySelector('svg').style.stroke = '#0B2C5F';
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0B2C5F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>

          {/* Slide actuel */}
          <div style={{
            background: '#fff',
            borderRadius: '20px',
            padding: '48px',
            boxShadow: '0 8px 30px rgba(11,44,95,0.12)',
            transition: 'all 0.5s ease',
            opacity: 1,
            transform: 'translateX(0)'
          }}>
            {/* Avatar */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #0B2C5F 0%, #1e40af 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              boxShadow: '0 4px 15px rgba(11,44,95,0.2)'
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>

            {/* Citation */}
            <div style={{
              textAlign: 'center',
              marginBottom: '24px'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
                <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
                <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/>
              </svg>
              <p style={{
                fontSize: '18px',
                lineHeight: '1.8',
                color: '#374151',
                fontStyle: 'italic',
                marginBottom: '24px'
              }}>
                "{testimonials[currentSlide].quote}"
              </p>
            </div>

            {/* Infos */}
            <div style={{ textAlign: 'center' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 700,
                color: '#0B2C5F',
                marginBottom: '4px'
              }}>
                {testimonials[currentSlide].name}
              </h3>
              <p style={{
                fontSize: '14px',
                color: '#6B7280',
                marginBottom: '8px'
              }}>
                {testimonials[currentSlide].title}
              </p>
              <span style={{
                display: 'inline-block',
                padding: '4px 12px',
                borderRadius: '20px',
                background: 'rgba(11,44,95,0.08)',
                color: '#0B2C5F',
                fontSize: '12px',
                fontWeight: 600
              }}>
                {testimonials[currentSlide].category} • {testimonials[currentSlide].year}
              </span>
            </div>
          </div>

          {/* Indicateurs */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            marginTop: '24px'
          }}>
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                style={{
                  width: index === currentSlide ? '24px' : '8px',
                  height: '8px',
                  borderRadius: '4px',
                  background: index === currentSlide ? '#0B2C5F' : '#D1D5DB',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease'
                }}
              />
            ))}
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Partenaires */}
      <section className="ema-block">
        <h2 className="ema-h3">Témoignages de nos partenaires</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Partenariat international</h3>
            <p className="ema-paragraph">
              "L'EMA est un partenaire essentiel dans le renforcement de l'état de droit en Haïti. La qualité de
              sa formation et l'engagement de ses diplômés contribuent significativement à l'amélioration du
              système judiciaire."
            </p>
            <p className="ema-muted" style={{ marginTop: 8 }}>
              - Représentant d'organisation internationale
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Institution nationale</h3>
            <p className="ema-paragraph">
              "Les magistrats formés à l'EMA font preuve d'un professionnalisme remarquable. Leur formation
              rigoureuse se traduit par des décisions de qualité et une gestion efficace des dossiers."
            </p>
            <p className="ema-muted" style={{ marginTop: 8 }}>
              - Responsable institutionnel
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Impact */}
      <section className="ema-block">
        <h2 className="ema-h3">Impact de notre formation</h2>
        <div className="ema-grid-3" style={{ marginTop: 14 }}>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#3b82f6' }}>95%</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Taux de satisfaction</div>
          </div>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#3b82f6' }}>90%</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Insertion professionnelle</div>
          </div>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#3b82f6' }}>85%</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Recommandation</div>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
